(() => {
  if (customElements.get('mh-delivery-estimate')) return;

  class MhDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.form = this.querySelector('[data-delivery-form]');
      this.input = this.querySelector('[data-delivery-pincode]');
      this.button = this.querySelector('[data-delivery-check]');
      this.message = this.querySelector('[data-delivery-message]');
      this.purchaseDate = this.querySelector('[data-purchase-date]');
      this.dispatchDate = this.querySelector('[data-dispatch-date]');
      this.deliveryDate = this.querySelector('[data-delivery-date]');
      this.resultTitle = this.querySelector('[data-delivery-result-title]');
      this.storageKey = this.dataset.storageKey || 'mh-delivery-pincode';

      this.input?.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
        this.clearError();
      });
      this.form?.addEventListener('submit', (event) => this.checkPincode(event));

      let savedPincode = '';
      try { savedPincode = window.localStorage.getItem(this.storageKey) || ''; } catch (error) { /* Storage can be disabled. */ }
      if (/^\d{6}$/.test(savedPincode) && this.input) this.input.value = savedPincode;
      this.renderEstimate(savedPincode);
    }

    checkPincode(event) {
      event.preventDefault();
      const pincode = (this.input?.value || '').replace(/\D/g, '');
      if (!/^\d{6}$/.test(pincode)) {
        this.classList.add('has-error');
        this.input?.setAttribute('aria-invalid', 'true');
        if (this.message) this.message.textContent = 'Please enter a valid 6-digit Indian pincode.';
        this.input?.focus();
        return;
      }

      try { window.localStorage.setItem(this.storageKey, pincode); } catch (error) { /* The estimate still works without storage. */ }
      this.classList.add('is-checked');
      this.clearError();
      this.renderEstimate(pincode);
      if (this.message) this.message.textContent = `Estimate updated for pincode ${pincode}.`;
      if (this.button) this.button.textContent = 'Update';
    }

    clearError() {
      this.classList.remove('has-error');
      this.input?.removeAttribute('aria-invalid');
    }

    renderEstimate(pincode) {
      const today = new Date();
      today.setHours(12, 0, 0, 0);
      const arrival = this.rangeForPincode(pincode);
      const dispatchStart = this.addWorkingDays(today, 1);
      const dispatchEnd = this.addWorkingDays(today, 2);
      const arrivalStart = this.addWorkingDays(today, arrival.min);
      const arrivalEnd = this.addWorkingDays(today, arrival.max);

      if (this.purchaseDate) this.purchaseDate.textContent = this.formatDate(today);
      if (this.dispatchDate) this.dispatchDate.textContent = this.formatRange(dispatchStart, dispatchEnd);
      if (this.deliveryDate) this.deliveryDate.textContent = this.formatRange(arrivalStart, arrivalEnd);
      if (this.resultTitle) {
        this.resultTitle.textContent = /^\d{6}$/.test(pincode)
          ? `Estimated delivery to ${pincode}: ${this.formatRange(arrivalStart, arrivalEnd)}`
          : `Estimated India delivery: ${this.formatRange(arrivalStart, arrivalEnd)}`;
      }
    }

    rangeForPincode(pincode) {
      if (!/^\d{6}$/.test(pincode)) return { min: 5, max: 9 };
      const prefix = Number(pincode.slice(0, 2));
      const metroPrefixes = new Set([11, 40, 50, 56, 60, 70]);
      if (prefix >= 36 && prefix <= 39) return { min: 3, max: 5 };
      if (metroPrefixes.has(prefix)) return { min: 4, max: 7 };
      if ((prefix >= 74 && prefix <= 79) || (prefix >= 90 && prefix <= 99)) return { min: 6, max: 10 };
      return { min: 5, max: 9 };
    }

    addWorkingDays(startDate, days) {
      const date = new Date(startDate);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0) added += 1;
      }
      return date;
    }

    formatDate(date) {
      return new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short', timeZone: 'Asia/Kolkata' }).format(date);
    }

    formatRange(startDate, endDate) {
      return `${this.formatDate(startDate)} – ${this.formatDate(endDate)}`;
    }
  }

  customElements.define('mh-delivery-estimate', MhDeliveryEstimate);
})();
